import * as React from "react";
import {MouseEvent} from "react";
import Style from "../../../_data/models/Style";
import {PrimaryModels} from "../../../_definitions/styleteq";
import ModalStyleComponent from "../components/ModalStyleComponent";
import {connect} from "react-redux";
import Meta from "../../../_data/models/Meta";
import {fetchCommentsByStyle} from "../../../comment/middlewares";
import {feedsCommentsSelector} from "../../selectors";
import {userByIdSelector} from "../../../_data/selectors";

interface Props {
    style: Style;
    toggleLike: (e: MouseEvent<HTMLElement>, model: PrimaryModels) => void;
}


const mapStateToProps = (state, props: Props) => {
    const {style} = props;

    return {
        user: userByIdSelector(state, style.userId),
        comments: feedsCommentsSelector(state)
    };
};

const mapDispatchToProps = (dispatch, props: Props) => {
    const {style} = props;

    return {
        loadMoreComments: (meta: Meta) => {            
            if (!meta) {
                dispatch(fetchCommentsByStyle(style.id, 1));
            } else if (meta && meta.hasNext()) {
                dispatch(fetchCommentsByStyle(style.id, meta.nextPage));
            }
        }
    };
};

const ModalStyleContainer = connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(ModalStyleComponent);
export default ModalStyleContainer;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/modal/containers/ModalStyleContainer.tsx